import type { ApiAddress } from '#/api/types/ApiAddress';
import { lookupAddressWithState } from '#/utils/address/lookupAddressWithState';
import { isEmpty } from '#/utils/functional/poly';

function getTextSearchQuery(address: Partial<ApiAddress>) {
  const { line1, city, state, zipcode, country } = address;
  return [line1, city, state, zipcode, country]
    .filter((value) => value)
    .join(',');
}

type Args = {
  currentAddress: Partial<ApiAddress>;
  setFetchingAddress: (arg0: boolean) => void;
};

export async function addressFormLookupAddressInternal({
  currentAddress,
  setFetchingAddress,
}: Args) {
  const addressIsEmpty = currentAddress.locationHidden
    ? isEmpty(currentAddress.city) && isEmpty(currentAddress.state)
    : isEmpty(currentAddress.line1) &&
      isEmpty(currentAddress.city) &&
      isEmpty(currentAddress.state) &&
      isEmpty(currentAddress.zipcode);

  if (addressIsEmpty) return {};

  const address = await lookupAddressWithState({
    query: getTextSearchQuery(currentAddress),
    country: currentAddress.country,
    state: currentAddress.state,
    acceptCityState: true,
  });

  setFetchingAddress(false);

  return address;
}
